import { createEffect, createSignal, on, onCleanup, onMount } from "solid-js";
import { isServer } from "solid-js/web";

import { isMobile } from "@/lib/isMobile";

// chart是否初始化完成

const getElementByIdPromise = (
  id: string = "embeddedMessagingFrame",
): Promise<HTMLIFrameElement> => {
  return new Promise((resolve) => {
    const iframe = document.getElementById(id) as HTMLIFrameElement | null;
    if (iframe) {
      resolve(iframe);
    } else {
      const timer = setInterval(() => {
        const iframe = document.getElementById(id) as HTMLIFrameElement | null;
        if (iframe) {
          clearInterval(timer);
          resolve(iframe);
        }
      }, 100);
    }
  });
};

export const hideChart = () => {
  // getElementByIdPromise().then((iframe) => {
  //   iframe.style.display = "none";
  // });
  // document.body.classList.remove("embeddedMessagingPreventScrolling");
  const iframe = document.getElementById("embeddedMessagingFrame");
  if (iframe) {
    iframe.style.display = "none";
  }
  // Hide the default chat button
  try {
    window?.embeddedservice_bootstrap?.utilAPI?.hideChatButton();
  } catch (e) {
    console.error("Error hiding chat button:", e);
  }
};

export const showChart = () => {
  getElementByIdPromise().then((iframe) => {
    iframe.style.display = "";
    const overlay = document.getElementById("embedded-messaging");
    if (overlay) {
      overlay.style.display = "";
    }
  });
};

export const launchChat = () => {
  if (isServer) {
    return Promise.resolve();
  }
  // launchChat && iframe加载完成返回true
  return new Promise((resolve) => {
    let isLaunchChated = false;
    const openChart = () => {
      if (window?.embeddedservice_bootstrap?.utilAPI?.launchChat) {
        if (!isLaunchChated) {
          window?.embeddedservice_bootstrap?.utilAPI?.launchChat();
          isLaunchChated = true;
        }

        getElementByIdPromise().then(() => {
          showChart();
          resolve(true);
        });
      } else {
        setTimeout(() => openChart(), 100);
      }
    };

    openChart();
  });
};

export const useChart = () => {
  // const addImportantStyle = (
  //   element: HTMLElement,
  //   styles: Record<string, string>,
  // ) => {
  //   for (const [prop, value] of Object.entries(styles)) {
  //     element.style.setProperty(prop, value, "important");
  //   }
  // };
  // 添加加载按钮样式
  const addBtnClass = function () {
    // closeDialog(DialogType.Salesforce);
    const iframe = document.getElementById("embeddedMessagingFrame");
    if (iframe) {
      iframe.classList.remove("window");
      iframe.classList.add("button");
      if (isMobile()) {
        iframe.classList.add("mobile");
      } else {
        iframe.classList.add("pc");
      }
    }
  };

  const addWindowClass = () => {
    const iframe = document.getElementById("embeddedMessagingFrame");
    if (iframe) {
      iframe.classList.remove("button");
      iframe.classList.add("window");
      if (isMobile()) {
        iframe.classList.add("mobile");
      } else {
        iframe.classList.add("pc");
      }
    }
  };

  const addEventListener = () => {
    window.addEventListener("onEmbeddedMessagingButtonCreated", function () {
      hideChart();
    });
    window.addEventListener("onEmbeddedMessagingWindowMinimized", function () {
      hideChart();
    });
    window.addEventListener("onEmbeddedMessagingWindowClosed", function () {
      // window.embeddedservice_bootstrap.utilAPI.removeAllComponent();
      hideChart();
    });
    window.addEventListener("onEmbeddedMessagingWindowMaximized", function () {
      showChart();
    });

    // window.addEventListener("onEmbeddedMessagingButtonCreated", () => {
    //   // 关闭loading按钮
    //   addBtnClass();
    // });
    // 最小化
    // window.addEventListener("onEmbeddedMessagingWindowMinimized", () => {
    //   addBtnClass();
    // });
    // window.addEventListener("onEmbeddedMessagingWindowClosed", () =>
    //   // todo: 关闭
    // );
    // 打开
    // window.addEventListener("onEmbeddedMessagingWindowMaximized", function () {
    //   addWindowClass();
    // });
    // onCleanup(() => {
    //   window.removeEventListener("onEmbeddedMessagingReady", () => {
    //     setReady(true);
    //   });
    //   window.removeEventListener("onEmbeddedMessagingButtonCreated", () =>
    //     hideChart(),
    //   );
    //   window.removeEventListener("onEmbeddedMessagingWindowMinimized", () =>
    //     hideChart(),
    //   );
    //   window.removeEventListener("onEmbeddedMessagingWindowClosed", () =>
    //     hideChart(),
    //   );
    // });
  };

  // TODO
  // createEffect(
  //   on(
  //     () => [userStore.token, ready()],
  //     async () => {
  //       if (ready()) {
  //         if (userStore.token && !isServer) {
  //           window.embeddedservice_bootstrap.userVerificationAPI.setIdentityToken(
  //             {
  //               identityTokenType: "JWT",
  //               identityToken: userStore.token,
  //             },
  //           );
  //         }
  //       }
  //     },
  //   ),
  // );

  const loadScript = () => {
    const script = document.createElement("script");
    script.defer = true;
    // script.src =
    //   "https://brilliantgame--uat.sandbox.my.site.com/ESWafunbetbr1758977976997/assets/js/bootstrap.min.js";
    script.src =
      "https://brilliantgame.my.site.com/ESWBrilliantChat1755193374601/assets/js/bootstrap.min.js";
    document.body.appendChild(script);
    return script;
  };

  const init = () => {
    if (isServer) return;

    const script = loadScript();
    script.onload = () => {
      try {
        addEventListener();
        embeddedservice_bootstrap.settings.language = "pt_BR";
        embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true; // <-- Desable the button chat

        embeddedservice_bootstrap.init(
          "00Das000009sVfy", // ORG ID
          "Brilliant_Chat", // Deployment Name
          "https://brilliantgame.my.site.com/ESWBrilliantChat1755193374601",
          {
            scrt2URL: "https://brilliantgame.my.salesforce-scrt.com",
          },
        );
      } catch (err) {
        console.error("Error loading Embedded Messaging: ", err);
      }

      // embeddedservice_bootstrap.init(
      //   "00Dbe000001yrfB",
      //   "afun_bet_br",
      //   "https://brilliantgame--uat.sandbox.my.site.com/ESWafunbetbr1758977976997",
      //   {
      //     scrt2URL: "https://brilliantgame--uat.sandbox.my.salesforce-scrt.com",
      //   },
      // );
    };
  };
  onMount(() => init());
};
